let language = {
    CART_PROGRESSBAR_PRODUCT:"选择商品",
    CART_PROGRESSBAR_SHIP:"填写信息",
    CART_PROGRESSBAR_PAYMENT:"审核与付款",
    
}

export { language }